import { render, staticRenderFns } from "./CeisaBarangImporIndex.vue?vue&type=template&id=0c43a350&scoped=true&"
import script from "./CeisaBarangImporIndex.vue?vue&type=script&lang=js&"
export * from "./CeisaBarangImporIndex.vue?vue&type=script&lang=js&"
import style0 from "./CeisaBarangImporIndex.vue?vue&type=style&index=0&id=0c43a350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43a350",
  null
  
)

export default component.exports